import React, { useEffect, useRef, useState } from 'react';
import { getUserAvatar } from '@helpers/GlobalFunctions';
import "./avatar.css";

const Avatar = ({ src = null, username = "user avatar", size = "default", colorFlip = false, center = false }) => {

    const [imageSrc, setImageSource] = useState(null)
    const avatarRef = useRef(false);

    useEffect(() => {
        if (avatarRef.current === false) {
            avatarRef.current = true;
            let name = username.split(' ')
                .map((str) => str ? str[0].toUpperCase() : "")
                .slice(0, 2)
                .join('') //.substring(0, 2).toUpperCase();

            setImageSource(getUserAvatar(name, colorFlip))
        }

    }, [src, colorFlip, username])

    return (
        <div className={`avatar-wrapper user-avatar-${size} ${center ? "mx-auto" : ""}`}>
            <img src={src ?? imageSrc} alt={username + " Avatar"} onError={(ev) => ev.currentTarget.src = imageSrc || ""}
                className={`user-avatar user-avatar-circle user-avatar-${size}`} style={{ width: size === "lg" ? "48px" : size === "xl" ? "100px" : size === "sm" ? "24px" : size === "default" ? "32px" : "32px", height: size === "lg" ? "48px" : size === "xl" ? "100px" : size === "sm" ? "24px" : size === "default" ? "32px" : "32px" }} />
            {/* <Canvas source={src || imageSrc} fallback={imageSrc} onFallback={onFallback}
                className={`user-avatar user-avatar-circle user-avatar-${size}`} alt={username + " Avatar"}
                imageClassList={"user-avatar-img"} imageStyle={"object-fit: cover"} fallbackMessage={fallbackMessage} /> */}
        </div>
    );
};

export default Avatar;